import classNames from 'classnames';

import Title from '@ui/Title';

import SvgGirl from './images/girl.svg';

import s from './NoProductsPlaceholder.sss';

// types
type NoProductsPlaceholderProps = {
  className?: string;
  title: string;
  subTitle?: string;
  action?: React.ReactNode;
  imageSrc?: string;
  withImage?: boolean;
};

export const NoProductsPlaceholder: React.FC<NoProductsPlaceholderProps> = ({
  className,
  title,
  subTitle,
  action,
  imageSrc,
  withImage = true,
}) => (
  <div className={classNames(s.root, className)}>
    {withImage && (
      <img
        className={s.girlIcon}
        src={imageSrc || SvgGirl}
        alt="Without products"
      />
    )}

    <Title className={s.title} type="h3" bold={false}>
      {title}
    </Title>
    {
      subTitle
      && <div>{subTitle}</div>
    }

    {
      action
      && <div className={s.action}>{action}</div>
    }
  </div>
);

export default NoProductsPlaceholder;
